const router = useRouter()
const { fullPath } = useRoute()
export default async function (type?: string, query?: string) {
  const queryPath = { [type]: query }
  await router.push({
    fullPath,
    query: queryPath
  })
}
